/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPublishing = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2a3 3 0 1 0 1.293 5.708l1.535 1.535A4.977 4.977 0 0 0 7 12c0 1.02.305 1.967.828 2.757l-1.535 1.535a3 3 0 1 0 1.414 1.414l1.536-1.534c.79.523 1.738.828 2.757.828 1.02 0 1.967-.305 2.757-.828l1.535 1.535a3 3 0 1 0 1.414-1.414l-1.534-1.536c.523-.79.828-1.738.828-2.757 0-1.02-.305-1.967-.828-2.757l1.535-1.535a3 3 0 1 0-1.414-1.414l-1.536 1.534A4.977 4.977 0 0 0 12 7c-1.02 0-1.967.305-2.757.828L7.708 6.293A3 3 0 0 0 5 2zM4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm15-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-7 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-7 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm14 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPublishing as Publishing };
